function escapeName(name) {
  return String(name).replace(/\[([^\]]*)\]/g, ".$1");
}

export default escapeName;
